<template>
  <div class="viewer-container">
    
    <!-- 1. شريط التحكم العلوي -->
    <div class="control-bar d-flex justify-content-between align-items-center mb-3 p-2 rounded bg-light border shadow-sm">
      <div class="fw-bold text-primary">
        <i class="fas fa-book-reader ms-2"></i> 
        <span>{{ subjectName }}</span> 
        <span class="text-muted mx-2">|</span>
        <small class="text-dark">{{ studentName }}</small>
      </div>
      
      <div class="btn-group" dir="ltr">
        <!-- أزرار التقليب -->
        <button @click="flipNext" class="btn btn-dark btn-sm px-3" title="الصفحة التالية">
          <i class="fas fa-chevron-left"></i> التالي
        </button>
        <button @click="flipPrev" class="btn btn-dark btn-sm px-3" title="الصفحة السابقة">
          السابق <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- 2. منطقة عرض الكتاب (Flipbook) -->
    <div class="book-stage shadow-lg">
      <div id="book">
        
        <!-- أ) الغلاف الأمامي -->
        <div class="my-page" data-density="hard">
          <div class="page-content cover">
            <div class="cover-content">
              <img src="/img/logo/edu.png" alt="Logo" class="cover-logo mb-3" style="height: 80px; opacity: 0.8;">
              <h2 class="fw-bold text-primary-dark mb-4">كراسة إجابة</h2>
              
              <div class="student-info-box">
                <p><strong>الطالب:</strong> {{ studentName }}</p>
                <p><strong>المادة:</strong> {{ subjectName }}</p>
                <p><strong>عدد الأوراق:</strong> {{ images.length }}</p>
              </div>

              <div class="mt-5 text-muted small blinking-text">
                <i class="fas fa-hand-pointer me-1"></i> اضغط للفتح
              </div>
            </div>
          </div>
        </div>

        <!-- ب) الصفحات الداخلية (الصور) -->
        <div v-for="(imgUrl, index) in images" :key="index" class="my-page">
          <div class="page-content">
            <!-- رقم الصفحة -->
            <span class="page-number badge bg-light text-dark border">{{ index + 1 }}</span>
            
            <!-- الصورة -->
            <div class="image-wrapper">
               <img :src="imgUrl" class="exam-image" loading="lazy" />
            </div>
          </div>
        </div>

        <!-- ج) الغلاف الخلفي -->
        <div class="my-page" data-density="hard">
          <div class="page-content back-cover">
            <h4 class="text-white">نهاية الورقة</h4>
            <small class="text-white-50">لجنة النظام والمراقبة</small>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { PageFlip } from 'page-flip';

export default {
  name: "ExamPaperViewer",
  // استقبال البيانات من الصفحة الرئيسية
  props: {
    images: {
      type: Array,
      required: true,
      default: () => []
    },
    studentName: {
      type: String,
      default: 'طالب'
    },
    subjectName: {
      type: String,
      default: 'مادة'
    }
  },
  data() {
    return {
      pageFlip: null,
    };
  },
  mounted() {
    // ننتظر تحميل الـ DOM ثم نبدأ الكتاب
    if (this.images.length > 0) {
        setTimeout(() => {
            this.initBook();
        }, 500);
    }
  },
  // مراقب: إذا تغيرت الصور (اختار مادة جديدة)، نعيد بناء الكتاب
  watch: {
    images(newVal) {
        if (this.pageFlip) {
            this.pageFlip.destroy(); // تدمير القديم
            this.pageFlip = null;
        }
        if (newVal && newVal.length > 0) {
            setTimeout(() => {
                this.initBook();
            }, 500);
        }
    }
  },
  beforeDestroy() {
    if (this.pageFlip) {
      this.pageFlip.destroy();
    }
  },
  methods: {
    initBook() {
      const element = document.getElementById('book');
      if (!element) return;

      this.pageFlip = new PageFlip(element, {
        width: 550, // عرض الصفحة
        height: 750, // ارتفاع الصفحة
         direction: 'rtl',
        // إعدادات التجاوب
        size: 'stretch',
        minWidth: 315,
        maxWidth: 1000,
        minHeight: 400,
        maxHeight: 1350,
        
        maxShadowOpacity: 0.5, // ظل عند الثني
        showCover: true,
        mobileScrollSupport: false // تعطيل سكرول الصفحة أثناء التقليب في الموبايل
      });

      // تحميل الصفحات من الـ HTML الموجود
      this.pageFlip.loadFromHTML(document.querySelectorAll('.my-page'));
    },

    flipNext() {
      if(this.pageFlip) this.pageFlip.flipNext();
    },
    flipPrev() {
      if(this.pageFlip) this.pageFlip.flipPrev();
    }
  }
};
</script>

<style scoped>
/* حاوية الخلفية (رمادي غامق لتركيز النظر) */
.exam-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
  
  /* --- فلتر السكانر (CSS Filter) --- */
  /* 1. contrast: زيادة التباين لتوضيح الخط */
  /* 2. brightness: تفتيح الخلفية */
  /* 3. saturate: زيادة تشبع الألوان لتبرز الأختام والأحمر */
  /* filter: contrast(125%) brightness(110%) saturate(130%); */
}
.book-stage {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #3e4144; 
  padding: 40px 20px;
  border-radius: 8px;
  min-height: 600px;
  overflow: hidden;
   direction: ltr; 
}

/* الصفحة نفسها */
.my-page {
  background-color: #fff;
  border: 1px solid #ccc;
  overflow: hidden;
}

/* محتوى الصفحة الداخلية */
.page-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* حاوية الصورة لضبط الأبعاد */
.image-wrapper {
  flex-grow: 1;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

/* الصورة نفسها */
.exam-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* يضمن ظهور الصورة كاملة دون قص */
  display: block;
}

/* رقم الصفحة */
.page-number {
  position: absolute;
  bottom: 15px;
  right: 15px; /* أو left حسب التفضيل */
  z-index: 10;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

/* تنسيق الغلاف الأمامي */
.cover {
  background: #fdfbfb;
  border: 8px double #0d47a1; /* إطار مزدوج أزرق */
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #333;
}

.cover-content {
  width: 80%;
  padding: 20px;
  border: 1px dashed #ccc;
  background: #fff;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
}

.student-info-box {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 5px;
  text-align: right;
  margin-top: 20px;
  border-right: 4px solid #ffc107; /* خط ذهبي */
}

.student-info-box p {
  margin-bottom: 8px;
  font-size: 1.1rem;
}

/* تنسيق الغلاف الخلفي */
.back-cover {
  background-color: #2c3e50;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-left: 5px solid #1a252f; /* تأثير كعب الكتاب */
}

/* تأثير الوميض للنص */
.blinking-text {
  animation: blinker 2s linear infinite;
}
@keyframes blinker {
  50% { opacity: 0.5; }
}
</style>